import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult, BillDataEntity } from "../../entities/BillEntity";
import type { ApprovalAuditPayload } from "../../../../../shared/utils/reviewWorkflow";

/**
 * Create Zoho Bill Use Case
 * Creates a bill in Zoho Books
 */
export class CreateZohoBillUseCase {
  constructor(private repository: BillRepository) {}

  async execute(
    billId: string,
    billData: BillDataEntity,
    pdfUrl: string,
    approvalAudit?: ApprovalAuditPayload,
  ): Promise<BillOperationResult> {
    // Validate inputs
    // if (!billId || billId.trim() === "") {
    //   throw new Error("Bill ID is required");
    // }

    // if (!billData) {
    //   throw new Error("Bill data is required");
    // }

    // if (!pdfUrl || pdfUrl.trim() === "") {
    //   throw new Error("PDF URL is required");
    // }

    // // Validate required bill data
    // if (!billData.vendor_id || billData.vendor_id.trim() === "") {
    //   throw new Error("Vendor ID is required");
    // }

    // if (!billData.bill_number || billData.bill_number.trim() === "") {
    //   throw new Error("Bill number is required");
    // }

    // if (!billData.line_items || billData.line_items.length === 0) {
    //   throw new Error("At least one line item is required");
    // }

    return await this.repository.createZohoBill(
      billId,
      billData,
      pdfUrl,
      approvalAudit,
    );
  }
}
